import type { AppLayoutKind } from "@ui/layouts/layoutProvider";
import {
	agencyIdForBoardContext,
	clipContextForAppKind,
} from "@ui/molecules/AddToBoard/useAddToBoard";
import { createBoard } from "@/client";
import type { AddBoardFormData } from "~/modules/askgvt/boards/list/components/NewBoardButton";
import { isValidationError422 } from "~/modules/shared/utils/isValidationError.typeguard";
import type { BoardInfo } from "./addToBoardSave";

export type CreateBoardResult =
	| { ok: true; board: BoardInfo & { id: string } }
	| { ok: false; errors?: Record<string, string[]> };

/** Create a board in the context the current app writes clips to. */
export async function createBoardForContext(params: {
	formData: AddBoardFormData;
	appKind: AppLayoutKind;
	projectId?: string;
}): Promise<CreateBoardResult> {
	const context = clipContextForAppKind(params.appKind);
	const response = await createBoard({
		body: {
			title: params.formData.title,
			description: params.formData.description ?? undefined,
			privacy: params.formData.privacy,
			context,
			project_id: context === "roster" ? undefined : params.projectId,
			agency_id: agencyIdForBoardContext(context),
			icon: params.formData.icon || null,
		},
	});

	if (isValidationError422(response)) {
		return { ok: false, errors: response.error.errors ?? {} };
	}
	if (response.response.status !== 201 || !response.data?.id) {
		return { ok: false };
	}

	return {
		ok: true,
		board: {
			id: response.data.id,
			title: response.data.title ?? params.formData.title,
		},
	};
}
